<template>
  <div style="width: 100%">
    <headers2 :title="titles"></headers2>

    <div class="contentBox">

      <div class="content">
        <div class="mzsm">
          <el-button type="primary" size="small" @click="toMzsm">免责声明</el-button>
        </div>


        <el-card class="box-card">
          <el-form :inline="true" label-width="150px" :model="formInline" class="demo-form-inline">
              <el-form-item label="省份" >
                <el-input v-model = "formInline.province"  class="width1"></el-input>
              </el-form-item>
              <el-form-item label="市场主体" >
                <el-input v-model = "formInline.company" class="width1"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码" >
                <el-input v-model = "formInline.creditId" class="width1"></el-input>
              </el-form-item>
              <el-form-item label="地理标志" >
                <el-input v-model = "formInline.productName" class="width1"></el-input>
              </el-form-item>

            <el-form-item label=" ">
              <el-button type="primary"   class=" btn1" @click.prevent="handleSearch" >查询</el-button>
               <el-button type="primary"  class=" btn1" @click ="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <div class="tipBox">
          <img src="../../assets/lb.png">
          <span style="font-size: 14px;color: #333333">提示说明: 本次检索结果仅显示截目前已完成换标的市场主体信息，对于在产品保护要求中列明的专用标志使用企业，如尚未完成换标，不会在本结果显示。</span>

        </div>

        <!-- 结果列表-->
        <Table
          ref="tableData"
          :fieldData="fieldData"
          :tableData="tableData"
          :page="true"
          @pageChange="pageChange"
          :total="total"
          :pageIndex="currentPage"
          :cellStyles="cellStyles"
          :headerStyles="headerStyles"
          style="width: 100%;"
        >

        </Table>

      </div>


    </div>


    <el-dialog
      title="免责声明"
      :visible.sync="dialogVisible"
      :show-close="false"
      :center="true"
      width="50%">
      <div class="title">使用说明</div>
      <div class="text">本栏目为社会公众提供统一地理标志专用标志使用企业信息查询，本系统的数据信息并非实时更新，有一定滞后性，仅供参考，不具有法律效力，以国家知识产权局官方公告信息为准。</div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">我接受</el-button>
    </span>
    </el-dialog>


    <footers></footers>
  </div>
</template>

<script>
import headers2 from "../../../comm/components/headers2.vue";
import pos_top1 from  "../../../comm/components/pos_title_top.vue"
import footers from '@comm/components/footers.vue'
import {logoSearch} from "../../api/query";
import Table from "../../../comm/components/Table/index.vue"
export default {
  name: "index",
  components:{
    headers2,pos_top1,footers,Table
  },
  data(){
    return{
      titles:'专用标志使用企业检索',
      dialogVisible:false,
      activeName:'first',
      currentPage:1,
      total: 0,       // 总记录数
      pageSize: 10,   // 每页的数据条数 需要与table组件里的一致
      //表格样式
      headerStyles:
        {
          color:'rgb(255, 255, 255)',
          padding: '0.375rem',
          'border-right': '2px solid #ffffff',
          'text-align': 'center',
          background: 'rgb(27, 61, 109)'
        },
      cellStyles: {'text-align': 'center'},
      tableData:[],
      fieldData:[
        {

          field:"province",
          label:"省份",
          width:"",
          sortable:false

        },

        {

          field:"productName",
          label:"地理标志",
          width:"",
          sortable:false

        },

        {

          field:"company",
          label:"市场主体",
          width:"",
          sortable:false

        },

        {

          field:"creditId",
          label:"统一社会信用代码",
          width:"",
          sortable:false

        },

      ],
      formInline:{
        province:'',
        productName:'',
        company:'',
        creditId:'',
        page:'1',
      }
    }
  },

  created() {
    // this.dialogVisible = true

  },


  methods:{
    //免责声明
    toMzsm(){

      this.dialogVisible = true

    },
   //查询
    handleSearch(){
      if (this.formInline.province == '' && this.formInline.productName == '' && this.formInline.company == '' && this.formInline.creditId == ''){

        this.$message.warning('请输入检索条件')

      }else {
        this.formInline.page = 1
        this.getData()
      }



    },

    getData(){

      const loading = this.$loading({
        lock: true,
        text: '正在加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      logoSearch(this.formInline).then(res=>{
        if (res.errorCode == 200){
          loading.close()
          this.tableData = res.data.data
          this.total = res.data.count

        }


      })
    },
    //重置
    handleReset(){

      this.formInline.province = ''
      this.formInline.productName = ''
      this.formInline.company = ''
      this.formInline.creditId = ''
      this.formInline.page = '1'

    },

    // 分页
    pageChange(pageIndex) {
      this.formInline.page = pageIndex;
      this.getData()
    },

  }
}
</script>
<style>
/* 隐藏滚动条 */
::-webkit-scrollbar {
  display: none;
}

/* 确保内容可滚动 */
.scrollable {
  overflow-y: scroll; /* 对于垂直滚动 */
}
</style>
<style scoped lang="less">

.contentBox{
  width: 100%;
  min-height: 100vh-40rem;
  display: flex;
  justify-content: center;


  .content{
    display: block;
    width: 75rem;
    //background: #ff6700;

    .mzsm{
      text-align: right;
      margin-bottom: 0.875rem;
    }
  }

}
.title{
  font-weight: bold;
  font-size: 1.25rem;
}
.text{
  margin-top: 1.25rem;
  text-indent: 2em;
  line-height: 2rem;
  font-size: 1rem;
}

.policy{
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  background: rgb(255, 255, 255);
  padding:2rem 3.4375rem;
}
.seeMore{
  z-index: 999999;
  box-sizing: border-box;
  border: 1px solid rgb(1, 137, 220);
  border-radius: 20px;
  background: rgb(255, 255, 255);
  color: rgb(1, 137, 220);
  float: right;margin-top: .7rem;
  cursor: pointer;
}
.lines .el-tabs__nav-wrap::after{
  background: none;
}
.lines .el-tabs__item.is-active{
  font-size: 1.25rem;
  color: rgb(27, 61, 109);

}
.lines .el-tabs__item{
  font-size: 1.25rem;
  color: rgb(186, 196, 211);
}

.seemores .el-tabs__header{
  width: 30% !important;
}

.tipBox{
  height: 2rem;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/landmark-user/views/zybzqyQuery/index.vue